{
  "header": {
    "title": "Profil",
    "description": "Hantera ditt användarkonto"
  },
  "tabs": {
    "settings": {
      "label": "Inställningar",
      "saveChangeButton": "Spara ändringar",
      "photoSection": {
        "title": "Foto",
        "changePhotoButton": "Byt foto",
        "maxSize": "Max. 5 MB",
        "format": "PNG-, JPG-format"
      },
      "personalInformationSection": {
        "title": "Personlig information",
        "nonEditable": {
          "nameInput": { "label": "Namn" },
          "jobTitleInput": { "label": "Jobbtitel" },
          "managerNameInput": { "label": "Chefens namn" },
          "userRoleInput": { "label": "Användarroll" },
          "emailInput": { "label": "E-post" },
          "departmentInput": { "label": "Avdelning" },
          "tenureInput": { "label": "Anställningstid" }
        },
        "editable": {
          "languageInput": { "label": "Språk" },
          "dateFormatInput": { "label": "Datumformat" },
          "locationInput": { "label": "Plats" },
          "timeZoneInput": { "label": "Tidszon" }
        }
      },
      "emailPreferencesSection": {
        "weeklyDigest": "Skicka ett veckobrev med senaste frågorna",
        "monthlyDigest": "Skicka ett månadsbrev med dina insikter"
      }
    },
    "directReports": {
      "label": "Mina direktrapporter",
      "emptyState": {
        "title": "Inga direktrapporter",
        "description": "Du har inga direktrapporter ännu. När personer rapporterar till dig visas de här."
      },
      "error": {
        "title": "Kunde inte läsa in direktrapporter",
        "description": "Något gick fel när dina direktrapporter skulle läsas in. Försök igen.",
        "retry": "Försök igen"
      }
    }
  }
}
